<template>
	<div class="upload-intro">
		<div class="title">如何上传剧本</div>
		<p class="content-item">为了增加编剧和剧本的曝光量，进而组成剧本交易，我们建议您通过“北门中文网”PC端进行剧本上传。</p>
		<p class="content-item list-title">具体操作如下</p>
		<p class="content-item">在PC端浏览器输入网址：www.beimen.com或通过搜索引擎搜索“北门中文网”，在首页进行登录/注册后，点击上导航上传剧本按钮，进入上传页面。</p>
		<p class="content-item"><img src="../assets/img/nav.png" alt=""></p>
		<p class="content-item list-title">第一步</p>
		<p class="content-item">如果您没进行实名验证，首先需要进行实名验证，填写您本人身份证号一句身份证姓名，及本人手机号。</p>
		<p class="content-item"><img src="../assets/img/authen.png" alt=""></p>
		<p class="content-item list-title">第二步</p>
		<p class="content-item">完成实名验证后填写剧本基本信息：点击‘保存按钮’ 保存至个人中心我的草稿。</p>
		<p class="content-item"><img src="../assets/img/basicinfo.png" alt=""></p>
		<p class="content-item">点击‘下一步按钮’进行上传剧本文件。</p>
		<p class="content-item list-title">第三步</p>
		<p class="content-item">上传文件，电影类型只能上传一个文件，电视剧类型的剧本可上传多个文件，一个文件是一集，上传完成后点击‘提交审核按钮’提交至后台，网站后台管理人员会在1-2工作日内审核您的剧本。</p>
		<p class="content-item"><img src="../assets/img/upload.png" alt=""></p>
	</div>
</template>

<script>
export default {
	name:'UploadIntro'
}
</script>
<style lang="scss" scoped>
	.upload-intro{
		padding:150px 46px 80px 46px;
		.title{
			color:#222;
			font-weight:bold;
			font-size:30px;
			margin-bottom:36px;
		}
		.content-item{
			font-size:26px;
			line-height:40px;
			color:#222;
			margin-bottom:22px;
			img{
				width:100%;
			}
		}
		.list-title{
			font-weight:bold;
			font-size:28px;
		}
	}
</style>